import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("shariti_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (error) => {
    if (error?.response?.status === 401 && !window.location.pathname.includes("/login")) {
      localStorage.removeItem("shariti_token");
      localStorage.removeItem("shariti_user");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

// Instance PUBLIQUE (sans token, sans redirection 401) — pour les pages
// accessibles sans compte, ex. l'accusé de réception du directeur de magasin.
export const publicApi = axios.create({ baseURL: API });

export default api;
